import { Section, H2, P, Bullets, Figure, Table, Callout } from "./Primitives";
import { BarChart } from "./Charts";

const IMG_COUNTER = "/images/counter.jpg";
const IMG_BABA = "/images/baba.jpg";

const ticket = [
  { label: "Oggi", value: 9.5 },
  { label: "Prudente", sub: "+3%", value: 9.79, highlight: true },
  { label: "Medio", sub: "+6%", value: 10.07, highlight: true },
  { label: "Aggressivo", sub: "+10%", value: 10.45, highlight: true },
];

const Standards = () => (
  <>
  <H2>Standardizzazione visiva e Risorse Umane</H2>
  <Bullets
    items={[
      <><strong>Layout visivo unificato</strong>: vetrine, esposizione del banco, illuminazione, cartellini prezzo e packaging con un'identità unica.</>,
      <><strong>Divise coordinate</strong> per banco e laboratorio, in linea con il nuovo posizionamento.</>,
      <><strong>Protocollo di accoglienza</strong>: saluto, consiglio sul prodotto, proposta della Linea Luxury e invito all'App, con un manuale operativo unico.</>,
      <><strong>Formazione ricorrente</strong> del personale con verifica della qualità del servizio per sede (mystery client trimestrale).</>,
      <>Investimento stimato per divise, materiali e packaging: <strong>circa € 2.200 per punto vendita</strong> (€ 15.400 complessivi), già incluso nel calcolo del rientro.</>,
    ]}
  />
  </>
);

const LuxuryLine = () => (
  <>
  <H2>La Linea Luxury</H2>
  <div className="grid md:grid-cols-[1fr_260px] gap-8 items-start">
    <div>
      <P>
        Nei <strong>3 punti vendita strategici</strong>, quelli con il maggior passaggio e il pubblico più alto-spendente, si introduce una linea firmata ad alto valore percepito.
        Alcuni esempi: il <strong>Babà all'oro alimentare 24k</strong>, la sfogliatella ai grani di vaniglia Bourbon, la pastiera in edizione numerata e le monoporzioni da vetrina.
      </P>
      <Bullets
        items={[
          <><strong>La linea classica resta a prezzi invariati</strong>: nessun rischio per la clientela storica.</>,
          <>Un prezzo unitario di <strong>€ 7,50–9,00</strong> contro € 3,50–4,00 del classico, con un margine lordo stimato superiore al 60%.</>,
          <>Basta che 1 cliente su 12 aggiunga un prodotto Luxury per alzare lo scontrino medio di oltre il 5%.</>,
          <>Effetto alone: la linea fa da <strong>vetrina di autorevolezza</strong> per regalistica, B2B e futuro franchising.</>,
        ]}
      />
    </div>
    <img src={IMG_BABA} alt="Babà con foglia d'oro alimentare" className="doc-img h-80 md:h-[340px]" data-testid="img-baba" />
  </div>
  <Figure caption="Figura 2 — Scontrino medio nei 3 punti vendita strategici. Linea classica a prezzi invariati; base ipotizzata € 9,50.">
    <BarChart testId="chart-ticket" data={ticket} format={(v) => "€ " + v.toFixed(2).replace(".", ",")} />
  </Figure>
  <Table
    testId="table-luxury"
    head={["Scenario", "Incremento scontrino", "Ricavi aggiuntivi / anno*", "Margine aggiuntivo / anno"]}
    rows={[
      ["Prudente (usato nel piano)", "+3%", "€ 44.600", "€ 22.300"],
      ["Medio", "+6%", "€ 89.200", "€ 44.600"],
      ["Aggressivo", "+10%", "€ 148.700", "€ 74.400"],
    ]}
    foot="* Su 3 punti vendita: circa 180 scontrini al giorno, € 9,50 di scontrino medio, 290 giorni di apertura effettiva. Margine prudenziale del 50%."
  />
  <Callout title="Perché funziona">
    La Linea Luxury non chiede alla clientela di pagare di più per ciò che compra già.
    Offre un motivo in più per spendere e rafforza il posizionamento del marchio senza toccare il listino classico.
  </Callout>
  </>
);

export const Brand = () => (
  <Section id="brand" num="04" kicker="Reparto Fisico e Riposizionamento" title="Brand Elevation">
    <img src={IMG_COUNTER} alt="Banco di pasticceria napoletana" className="doc-img h-64 sm:h-80 mb-10" data-testid="img-counter" />
    <P>
      La tecnologia moltiplica il valore di un marchio solo se l'esperienza in negozio è <strong>coerente e riconoscibile</strong> in ogni sede.
      Un cliente deve vivere la stessa Bella Napoli a ogni banco. È anche la condizione che un futuro affiliato vorrà vedere prima di investire.
    </P>
    <Standards />
    <LuxuryLine />
  </Section>
);
